import { render, staticRenderFns } from "./mapChina.vue?vue&type=template&id=62b6b5e9&scoped=true&"
import script from "./mapChina.vue?vue&type=script&lang=js&"
export * from "./mapChina.vue?vue&type=script&lang=js&"
import style0 from "./mapChina.vue?vue&type=style&index=0&id=62b6b5e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b6b5e9",
  null
  
)

export default component.exports